import React from "react";
import PreloadIMAGES from "@insightfulscience/smart-react/PreloadImages";
import { array } from "prop-types";

const assetUrl = `${process.env.SB_CDN_HOST}/assets`;

const PreloadImages = ({ imagesHref = [] }) => {
	return (
		<PreloadIMAGES
			host={assetUrl}
			imagesHref={[
				"/images/common/dotmatics-logo-white.svg",
				"/images/snapgene/logo/logo-snapgene.svg",
				"/images/snapgene/logo/logo-snapgene-dotmatics.svg",
				...imagesHref,
			]}
		/>
	);
};

PreloadImages.propTypes = {
	imagesHref: array,
};

export default PreloadImages;
